module.exports = __webpack_public_path__ + "static/media/equalicare-img03.350fab0f.png";